// How to order a catalogue product from a supplier
// (product_catalog_suppliers.how_to_order): either a link to the item on the
// supplier's site, or free text such as "Email Jane at Westcoast".

const URL_RE = /^https?:\/\/\S+$/i;
// Links and email addresses inside free text, so "Email jane@westcoast.co.uk
// or see https://…" renders both as something to click.
const TOKEN_RE = /(https?:\/\/[^\s<>"]+|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;

// The link, when the entry is nothing but a link; otherwise null. Only a bare
// link is fit for a hardware request's Product Link field.
export function orderLink(text) {
  const t = String(text || '').trim();
  return URL_RE.test(t) ? t : null;
}

// Splits the entry into plain text, links and email addresses for display.
// Trailing punctuation stays with the text, so "see https://x.com/a." links
// to https://x.com/a.
export function howToOrderParts(text) {
  const t = String(text || '').trim();
  if (!t) return [];
  const parts = [];
  let last = 0;
  for (const m of t.matchAll(TOKEN_RE)) {
    let token = m[0];
    const trail = token.match(/[.,;:!?)]+$/)?.[0] || '';
    if (trail) token = token.slice(0, -trail.length);
    if (m.index > last) parts.push({ type: 'text', value: t.slice(last, m.index) });
    parts.push(token.includes('@') && !/^https?:/i.test(token)
      ? { type: 'email', value: token, href: `mailto:${token}` }
      : { type: 'link', value: token, href: token });
    last = m.index + token.length;
  }
  if (last < t.length) parts.push({ type: 'text', value: t.slice(last) });
  return parts;
}

// "https://www.westcoast.co.uk/p/123" reads as "westcoast.co.uk" in a narrow
// column; the full address is in the title.
export function linkLabel(url) {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; }
}
